// src/components/BaseLayout.js
import React from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "./logo.png";

const drawerWidth = 220;
const sidebarBg = "#F8F8FF"; // Off-white/light purple
const sidebarAccent = "#EEF0FB"; // Slightly more purple for highlight
const highlightColor = "#6857FF"; // Button/active

const BaseLayout = ({ children, onNav, selectedNav, onResetSelectedUser }) => (
  <Box sx={{ display: "flex", minHeight: "100vh", background: "#f5f6fa" }}>
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          background: sidebarBg,
          borderRight: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: "22px",
          margin: "10px 0 10px 10px",
        },
      }}
    >
      {/* Top Section */}
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", px: 2, py: 3 }}>
          <img
            src={logo}
            alt="Magic R and owl"
            style={{
              width: "55px",
              height: "55px",
              objectFit: "cover",
              display: "block",
              borderRadius: "50%",
              marginRight: 10,
            }}
          />

          <Box
            sx={{
              fontWeight: "bold",
              fontSize: 18,
              letterSpacing: 0.5,
              color: "#1A1248",
            }}
          >
            readabled
          </Box>
        </Box>
        <List>
          <ListItem
            button
            selected={selectedNav === "inviteUser"}
            onClick={() => onNav("inviteUser")}
            sx={{
              borderRadius: "12px",
              my: 1,
              mx: 2,
              bgcolor:
                selectedNav === "inviteUser" ? sidebarAccent : "transparent",
              cursor: "pointer",
              "&:hover": { bgcolor: sidebarAccent, cursor: "pointer" },
            }}
          >
            <ListItemIcon>
              <AttachEmailIcon sx={{ color: highlightColor }} />
            </ListItemIcon>
            <ListItemText primary="Invite User" sx={{ color: "#2C275A" }} />
          </ListItem>
          <ListItem
            button
            selected={selectedNav === "users"}
            onClick={() => {
              if (onNav) onNav("users");
              if (onResetSelectedUser) onResetSelectedUser();
            }}
            sx={{
              borderRadius: "12px",
              my: 1,
              mx: 2,
              bgcolor: selectedNav === "users" ? sidebarAccent : "transparent",
              cursor: "pointer",
              "&:hover": { bgcolor: sidebarAccent, cursor: "pointer" },
            }}
          >
            <ListItemIcon>
              <PeopleIcon sx={{ color: highlightColor }} />
            </ListItemIcon>
            <ListItemText primary="Users" sx={{ color: "#2C275A" }} />
          </ListItem>
        </List>
      </Box>
      {/* Bottom Logout */}
      <Box sx={{ px: 2, pb: 2 }}>
        <Button
          fullWidth
          startIcon={<LogoutIcon />}
          sx={{
            background: highlightColor,
            color: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px #0001",
            py: 1.2,
            fontWeight: 600,
            textTransform: "none",
            "&:hover": { background: "#7d6bff", cursor: "pointer" },
          }}
          onClick={() => {
            localStorage.removeItem("token");
            window.location.href = "/auth";
          }}
        >
          Logout
        </Button>
      </Box>
    </Drawer>
    {/* Main Content */}
    <Box sx={{ flexGrow: 1, px: 4, height: "100vh" }}>{children}</Box>
  </Box>
);

export default BaseLayout;
